<span *ngIf="!completed; else showComplete" class="countdown-timer">
  {{ formattedTime$ | async }}
</span>
<ng-template #showComplete>
  <span>
    {{ completeText }}
  </span>
</ng-template>
